import axios from "axios";
export default {
    getRoles: () => axios.post("/Roles/GetRoles", {}),
    removeRoles: (ids) => axios.post("/Roles/RemoveRoles", { ids }),
    saveRole: (data) => axios.post("/Roles/SaveRole", data)
};
